(function($) {
    'use strict';

    const $window = $(window);
    const $document = $(document);
    const $body = $('body');

    /**
     * Save scroll pos
     */
    const getUrl = function() { return [location.protocol, '//', location.host, location.pathname].join(''); }
    const scrollpos = JSON.parse(localStorage.getItem('scrollpos'));
    if (scrollpos && scrollpos.url == getUrl()) {
        $(window).scrollTop(scrollpos.pos);
    }
    $(window).on('unload', function() {
        localStorage.setItem('scrollpos', JSON.stringify({
            pos: $window.scrollTop(),
            url: getUrl()
        }));
    });

    /**
     * Smooth hash scroll
     */
    $('a[href*="#"]').not('[href="#"]').click(function() {
        if (location.pathname.replace(/^\//,'') == this.pathname.replace(/^\//,'') && location.hostname == this.hostname) {
            let target = $(this.hash);
            target = target.length ? target : $('[name=' + this.hash.slice(1) +']');
            if (target.length) {
                $('html,body').animate({
                    scrollTop: target.offset().top
                }, 400);
                return false;
            }
        }
    });

    /**
     * Dynamic vh
     */
    /*
    const appHeight = () => {
        const header = document.getElementById('header');
        const footer = document.getElementById('footer');
        const doc = document.documentElement;
        doc.style.setProperty('--app-height', `${window.innerHeight}px`);
        doc.style.setProperty('--footer-height', `${footer.offsetHeight}px`);
        doc.style.setProperty('--header-height', `${header.offsetHeight}px`);
    }
    window.addEventListener('resize', appHeight);
    window.addEventListener('load', appHeight);
    appHeight();
    */

    /**
     * Scroll open accordion
     */
    function openActiveAccordion() {
        $('div.toggler').each(function() { 
            if (document.location.hash === '#' + $(this).parent().attr('id') && !$(this).hasClass('active')) { 
                $(this).click(); 
            } 
        });
    }

    function scrollToElement(element) {
        $(document).scrollTop(0);
        $('html, body').animate({
            scrollTop: element.offset().top
        }, 800);
    }   

    $(document).ready(function() {
        if (location.hash) {
            const $hash = location.hash;
            const $element = $($hash);

            if ($element.length > 0) {
                scrollToElement($element);
                setTimeout(function() {
                    openActiveAccordion();
                }, 800);
            }
        }
    });

    /**
     * news-latest hover
     */
    $('.news-latest').hover(function() {
        $body.addClass('news-latest-hover');
    }, function() {
        $body.removeClass('news-latest-hover')
    });

})(jQuery);
